import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@tsin-env/environment';
import {
    CreaJobOpeningInput,
    IJobOpeningModel,
    IJobOpeningRequest,
    IJobStatusInput,
    UpdateJobOpeningInput
} from './job-opening.types';
import { Observable } from 'rxjs';

const JOB_OPENING_URL = `${environment.apiBaseUrl}/jobs`;

@Injectable({
    providedIn: 'root'
})
export class JobOpeningService {
    http: HttpClient = inject(HttpClient);

    getJobs() {
        return this.http.get(JOB_OPENING_URL);
    }

    createJob(payload: CreaJobOpeningInput): Observable<IJobOpeningModel> {
        return this.http.post<IJobOpeningModel>(JOB_OPENING_URL, payload);
    }

    getSingle(id: string) {
        return this.http.get(JOB_OPENING_URL + `/single/${id}`);
    }

    getSingleSlug(slug: string) {
        return this.http.get(JOB_OPENING_URL + `/slug/${slug}`);
    }
    updateJob(payload: UpdateJobOpeningInput): Observable<IJobOpeningModel> {
        return this.http.put<IJobOpeningModel>(JOB_OPENING_URL, payload);
    }

    updateJobStatus(payload: IJobStatusInput): Observable<IJobOpeningModel> {
        return this.http.patch<IJobOpeningModel>(JOB_OPENING_URL, payload);
    }

    deleteJob(id: string) {
        return this.http.delete(JOB_OPENING_URL + `/single/${id}`);
    }

    getApplByJob(id: string) {
        return this.http.get(JOB_OPENING_URL + `/all-applications/${id}`);
    }
}
